/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export let ManagedEditingState = /*#__PURE__*/function (ManagedEditingState) {
  /** In this mode no buttons are shown */
  ManagedEditingState["CANNOT_BE_EDITED"] = "not editable";
  /** In this mode the edit button is shown */
  ManagedEditingState["CAN_BE_EDITED"] = "editable";
  /** In this mode a disabled save button is shown and the cancel button is shown */
  ManagedEditingState["EDITING_AND_CANNOT_BE_SAVED"] = "editing and cannot be saved";
  /** In this mode the save and cancel buttons are shown. */
  ManagedEditingState["EDITING_AND_CAN_BE_SAVED"] = "editing and can be saved";
  /** In this mode no buttons are shown. An enclosing panel has gone into edit mode, and we are controlled by that panel. */
  ManagedEditingState["EDITING_DUE_TO_PARENT"] = "editing due to parent";
  return ManagedEditingState;
}({});
export function isManagedEditingStateActivelyEditing(state) {
  switch (state) {
    case ManagedEditingState.EDITING_DUE_TO_PARENT:
    case ManagedEditingState.EDITING_AND_CAN_BE_SAVED:
    case ManagedEditingState.EDITING_AND_CANNOT_BE_SAVED:
      return true;
    default:
      return false;
  }
}
//# sourceMappingURL=ManagedEditingState.js.map
